import React from 'react';
import { render } from 'react-dom';
import { IntlProvider } from 'react-intl-next';
import { LinkAction, OverlayButton } from '@atlaskit/editor-common/link';
export var ButtonWrapper = function ButtonWrapper(_ref) {
  var editorView = _ref.editorView,
    pos = _ref.pos,
    stateKey = _ref.stateKey,
    intl = _ref.intl,
    onOpenLinkClick = _ref.onOpenLinkClick;
  var wrapper = document.createElement('span');
  wrapper.style.position = 'relative';
  var nonBreakingCharacter = "\u2060";
  var onDropdownChange = function onDropdownChange(isOpen) {
    editorView.dispatch(editorView.state.tr.setMeta(stateKey, {
      type: LinkAction.SET_CONFIGURE_DROPDOWN_OPEN,
      isOpen: isOpen
    }));
  };
  render( /*#__PURE__*/React.createElement(IntlProvider, {
    locale: intl.locale || 'en',
    messages: intl.messages,
    formats: intl.formats
  }, /*#__PURE__*/React.createElement(OverlayButton, {
    targetElementPos: pos,
    editorView: editorView,
    onDropdownChange: onDropdownChange,
    onOpenLinkClick: onOpenLinkClick
  }), nonBreakingCharacter), wrapper);
  return wrapper;
};